import {useEffect, useState} from "react";
import {EyeIcon, PencilSquareIcon,} from "@heroicons/react/24/solid";
import {Card, CardBody, IconButton, Typography} from "@material-tailwind/react";
import {useLocation, useNavigate} from "react-router-dom";
import {LoaderEllipsisComponent} from "../Loader/LoaderComponent";
import {DialogOfDeleteComponent} from "../Dialogs/DialogComponent";
import DataTable from 'react-data-table-component';
import {connect} from "react-redux";
import {ROWS_PER_PAGE, setMoney} from "../../../utils/shared";
import {SecondTrashIcon} from "../../../modules/Products/Create/FormPresentation";
import {NoDataComponent} from "./NoDataComponent";
import {TableSearchAndFilter} from "./TableSearchAndFilter";
import ExcelJS from 'exceljs';
import {saveAs} from 'file-saver';

export const tableCustomStyles = {
  headCells: {
    style: {
      fontSize: '14px',
      fontWeight: 'bold',
      backgroundColor: 'rgba(225,225,225,0.4)',
      height: '35px',
    },
  },
}

function TableWithStripedRowsComponent({data = [], columns = [], page = 1, ...props}) {
  const {loader = false, actionDelete, user, titleExcel, paginationServer= false, sumarColumna=''} = props;
  const [show, setShow] = useState(false);
  const [record, setItem] = useState(false);
  const [didMount, setMount] = useState(false);
  const [columnsFinal, setColumns] = useState(columns);
  const nav = useNavigate();
  const [hasPermission, setPermission] = useState(false)
  const [hasPermissionEdit, setPermissionEdit] = useState(false)
  const location = useLocation();
  const {results, count} = data

  useEffect(() => {
    setMount(true)
    validatePermission()
  }, [])

  useEffect(() => {
    validatePermission()
  }, [location, user, didMount]);

  const validatePermission = () => {
    if (location) {
      const views = localStorage.getItem('views')
      if (views === 'is_superuser') {
        setPermission(true)
        setPermissionEdit(true)
      } else {
        if (views) {
          const jsonViews = JSON.parse(views)
          jsonViews.forEach((ele) => {

            let split = ele.view_f.split(',');

            split.forEach((item) => {
              item = item.trim();
              if (item === location.pathname && ele.read) {
                setPermission(true)
              }
              if (item === location.pathname && ele.edit) {
                setPermissionEdit(true)
              }
            })
          })
        }
      }
    }
  }

  useEffect(() => {
    if (didMount && !props.dontShowAction) {
      const columnsWithAction = [
        ...columns,
        {
          selector: row => row.id,
          name: 'Acciones',
          cell: row => <div className="flex">
            <IconButton
              variant="text"
              className="py-0 my-0 text-black/60 hover:text-indigo-400 hover:bg-gray-100"
              onClick={() => nav(`${props.newRoute + 'detalle/' + row.id}`.replace('undefined', ''))}>
              <EyeIcon className="w-5 h-5 text-indigo-400"/>
            </IconButton>
            {hasPermissionEdit &&
              <>
                <IconButton
                  variant="text"
                  className="py-0 my-0 text-black/60 hover:text-amber-600 hover:bg-gray-100"
                  onClick={() => nav(`${props.newRoute + 'editar/' + row.id}`.replace('undefined', ''))}
                >
                  <PencilSquareIcon className="w-5 h-5 text-amber-600"/>
                </IconButton>
                <IconButton
                  onClick={() => openModalDelete(row)}
                  variant="text"
                  className="hover:text-red-500 text-black/60 py-0 my-0 flex justify-center items-center hover:bg-gray-100">
                  <SecondTrashIcon className="w-5 h-5 text-red-500">
                  </SecondTrashIcon>
                </IconButton>
              </>
            }
          </div>
        }
      ]
      setColumns(columnsWithAction)
    }
  }, [didMount, columns, nav, props.newRoute]);

  const openModalDelete = (item) => {
    setShow(true)
    setItem(item)
  }

  const confirmCallBack = () => {
    actionDelete && actionDelete(record.id)
  }

  const downloadExcel = async () => {
    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet('datosImportados');
    // Definir columnas
    let headers = [];
    const firstRow = ws.getRow(1);

    columns.map((colName, index) => {
      let itemHeader = {};
      itemHeader['header'] = colName.name;
      itemHeader['key'] = `col${index}`;
      if (colName.name.toUpperCase() === 'ID') {
        itemHeader['width'] = 10;
      } else {
        itemHeader['width'] = 32;
      }
      headers.push(itemHeader);
      // Estilos en la primera fila (encabezados)
      firstRow.getCell(index + 1).border = {
        top: {style: 'thin'},
        left: {style: 'thin'},
        bottom: {style: 'thin'},
        right: {style: 'thin'}
      };
      firstRow.getCell(index + 1).font = {bold: true, color: {argb: 'FFFFFFFF'}};
      firstRow.getCell(index + 1).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {argb: 'FF007ACC'} // Azul
      };

    })
    ws.columns = headers;

    // Se recorre los datos para agregarlos como fila
    results.map((result, indice) => {
      let valorFila = {}
      columns.map((colName, index) => {
        valorFila[`col${index}`] = colName.selector(result)
      })
      // Agregar filas
      ws.addRow(valorFila);
      let fila = ws.getRow(indice + 2);
      fila.height = 15;
    })

    if(sumarColumna != '') {
      // Agregar filas total
      let valorFila = {}
      valorFila[`col${columns.length - 1}`] = sumarTotalColumn()
      ws.addRow(valorFila);
      let filaTotal = ws.getRow(results.length + 2);
      filaTotal.getCell(columns.length - 1 + 1).font = {bold: true, color: {argb: 'FFFFFFFF'}};
      filaTotal.getCell(columns.length - 1 + 1).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {argb: 'FF007ACC'} // Azul
      };
    }

    // Guardar como archivo
    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    saveAs(blob, `${titleExcel}.xlsx`);
  }

  const sumarTotalColumn = ()=>{
    let total = 0
    results?.map((fila)=>{
      total += parseFloat(fila[sumarColumna])
    })
    return setMoney(total);
  }

  const paginationComponentOptions = {
    rowsPerPageText: 'Filas por página',
    rangeSeparatorText: 'de',
    selectAllRowsItem: false,
    selectAllRowsItemText: 'Todos',
  };

  return (
    <div className={hasPermission ? props.className ?? "" : 'hidden'}>
      <DialogOfDeleteComponent
        show={show}
        setShow={setShow}
        confirmCallBack={confirmCallBack}
      />
      <Card
        className={"h-max w-full shadow-sm " + props.classNameCard}>
        <TableSearchAndFilter {...props}/>
        <CardBody className="px-2 md:lg:xl:2xl:px-4">
          <LoaderEllipsisComponent loader={loader}/>
          <div className={`flex flex-row ${sumarColumna != ''? "justify-between items-end": "justify-end"} pb-2 gap-4`}>
            {
              sumarColumna != '' &&
              <Typography className="font-bold">Total: {sumarTotalColumn()}</Typography>
            }
            <IconButton color="gray" onClick={downloadExcel} type="button">
              <img alt="excel" src="/assets/excel.png" className="w-5 h-5 text-green-500"/>
            </IconButton>
          </div>
          <DataTable
            pagination
            columns={columnsFinal}
            data={results}
            dense
            paginationPerPage={ROWS_PER_PAGE}
            paginationDefaultPage={1}
            persistTableHead={false}
            customStyles={tableCustomStyles}
            // actions={actionsMemo}
            paginationServer={paginationServer}
            paginationTotalRows={count}
            onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
              if (didMount) {
                if (paginationServer) props.ChangeRowsPerPage(currentRowsPerPage);
              }
            }}
            onChangePage={(page, totalRows) => {
              if (didMount) {
                if (paginationServer) props.list(page);
              }
            }}
            noDataComponent={<NoDataComponent columns={columns}/>}
            paginationComponentOptions={paginationComponentOptions}
          />
        </CardBody>
      </Card>
    </div>

  );
}

const ExportButtonExcel = ({actionClick}) => {
  return (
    <IconButton color="gray" onClick={actionClick} type="button">
      <img alt="excel" src="/assets/excel.png" className="w-5 h-5 text-green-500"/>
    </IconButton>
  )
};

const states = (state) => {
  return {
    user: state.user.data,
  };
};
const TableWithStripedRows = connect(states, undefined)(TableWithStripedRowsComponent);
export {TableWithStripedRows}